export const REGEX_ALPHANUMERIC_WITH_SPACES = /^[a-zA-Z0-9_ ]+$/i;
